module.exports = __webpack_public_path__ + "static/media/cidade.e6895591.png";